export default "__VITE_ASSET__HL0PaNYV__"